import { render } from "./AppModal.vue?vue&type=template&id=cdf9e4fa&bindings={\"submitAction\":\"props\"}"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"
script.render = render

export default script